import React from 'react';
import { motion } from 'framer-motion';
export function BonusesSection() {
  const bonuses = [{
    number: 1,
    title: 'Protocolo de Ingreso y Screening Rápido',
    subtitle: 'La primera sesión organizada desde el minuto uno',
    description: 'Una ficha técnica completa para la primera consulta. Datos filiatorios · Antecedentes médicos · Screening cognitivo rápido con criterios de orientación · Decisión de nivel de inicio · Plan de intervención inicial. Nunca más vas a salir de una primera sesión sin saber exactamente por dónde empezar.',
    image: 'https://cdn.magicpatterns.com/uploads/auvxZXnp5PFjcd6sLM3YmG/bono_1_clinico-removebg-preview.png'
  }, {
    number: 2,
    title: 'Planificador de Sesiones y Ficha de Evolución',
    subtitle: 'El registro clínico que justifica el tratamiento ante la familia y ante cualquier médico',
    description: 'Planificador mensual de sesiones · Ficha de evolución por sesión · Semáforo de progreso por área · Gráfico de evolución trimestral · Síntesis mensual con decisión clínica incluida. El registro que demuestra que tu trabajo produce resultados concretos y medibles.',
    image: 'https://cdn.magicpatterns.com/uploads/bcZLqf1LCnDJpgekYAaXyS/ChatGPT_Image_7_may_2026__09_18_12_p.m.-removebg-preview.png'
  }, {
    number: 3,
    title: 'Kit de Cartelería: Orientación a la Realidad',
    subtitle: 'El consultorio que orienta solo, sin que vos tengas que repetirlo 20 veces',
    description: '5 carteles técnicos listos para imprimir y plastificar. Fecha y tiempo · Dónde estamos · Qué hacemos hoy · Recordatorios de autocuidado · Frase motivadora de la semana. El paciente llega, mira los carteles y baja la ansiedad antes de que vos diga una palabra.',
    image: 'https://cdn.magicpatterns.com/uploads/eTgB7YZDikpzCjKA2TBGbh/ChatGPT_Image_7_may_2026__09_19_33_p.m.-removebg-preview.png'
  }, {
    number: 4,
    title: 'Guía de Alertas Clínicas: Cuándo derivar al Neurólogo',
    subtitle: 'El escudo que te protege y te posiciona como profesional completa',
    description: 'Tabla comparativa envejecimiento normal vs. señales de alarma · Checklist de banderas rojas de derivación inmediata · Observación progresiva mensual · Scripts para comunicarle la derivación a la familia sin generar pánico · Modelo de nota de derivación · Referencia rápida de especialistas. Nunca más vas a dudar si lo que ves es vejez normal o patología. Y nunca más vas a no saber cómo decírselo a la familia.',
    image: 'https://cdn.magicpatterns.com/uploads/q83ZTRo9rVfiG8n6AMbMwJ/ChatGPT_Image_7_may_2026__09_20_46_p.m.-removebg-preview.png'
  }];
  return <section className="py-16 sm:py-24 bg-white" data-id="element-17">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-19">
          <div className="text-center mb-10" data-id="element-20">
            <p className="inline-block bg-amber-100 text-amber-800 font-bold uppercase tracking-wide text-sm px-4 py-2 rounded-full mb-4" data-id="element-21">
              🎁 Hoy te llevás de regalo gratis por tu compra
            </p>
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900" data-id="element-22">
              LAS 4 HERRAMIENTAS DE GESTIÓN CLÍNICA
            </h3>
          </div>

          <div className="space-y-6" data-id="element-23">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-gradient-to-r from-teal-50 to-cyan-50 p-6 rounded-lg shadow-md border-l-4 border-teal-600 hover:shadow-lg transition-shadow duration-300" data-id="element-24">
                <div className="flex flex-col md:flex-row items-start gap-4 md:gap-6" data-id="element-25">
                  <div className="bg-teal-600 text-white rounded-full w-12 h-12 flex items-center justify-center font-bold text-xl flex-shrink-0" data-id="element-26">
                    {bonus.number}
                  </div>
                  <div className="flex-1" data-id="element-27">
                    <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-28">
                      BONO {bonus.number} — {bonus.title}
                    </h4>
                    <p className="text-teal-700 font-semibold mb-3 italic" data-id="element-29">
                      {bonus.subtitle}
                    </p>
                    <p className="text-gray-700 leading-relaxed" data-id="element-30">
                      {bonus.description}
                    </p>
                  </div>
                  {bonus.image && <div className="w-full md:w-56 flex-shrink-0 flex justify-center" data-id="element-31">
                      <img src={bonus.image} alt={`Bono ${bonus.number} - ${bonus.title}`} className="w-full max-w-[220px] drop-shadow-xl hover:scale-105 transition-transform duration-300" data-id="element-32" />
                    </div>}
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}